<template>
    <div>
        <Header />
        <UserRoles />
    </div>
</template>
<script>
import Header from '@/components/header.vue'
import UserRoles from '@/components/userRoles.vue'
export default {
  name: 'roles',
  components: {
    Header,
    UserRoles
  },
  data () {
    return {
      loading: false
    }
  }
}
</script>
